import classNames from "classnames";
import Link from "next/link";

import { ProductColor } from "@/api/generatedTypes";

import styles from "./ColorsSection.module.scss";

interface ColorSectionProps {
  colors?: ProductColor[];
  currentColorName: string;
  vendorCode: string;
}

const ColorSection = ({
  colors = [],
  currentColorName,
  vendorCode,
}: ColorSectionProps) => {
  if (colors.length <= 1) return null;

  return (
    <>
      <div className={styles.info}>
        Цвет: {currentColorName}
        <span className={styles.vendorCode}>Арт: {vendorCode}</span>
      </div>
      <div className={styles.colors}>
        {colors.map((color) => (
          <Link
            key={color.id}
            href={`/product/${color.slug}`}
            replace
            className={classNames(styles.color, {
              [styles.current]: color.current,
              [styles.moreThanThree]: colors.length > 3,
            })}
          >
            <span
              className={styles.circle}
              style={{
                backgroundColor: color.hex,
              }}
            >
              {color.color}
            </span>
          </Link>
        ))}
      </div>
    </>
  );
};

export default ColorSection;
